<page-toolbar [title]="'chats.headTitle' | translate"></page-toolbar>

<page-content [noPadding]="true">
  <data-table (detail)="onDetail($event)" [columns]="columns" [dataProvider]="packageService" [title]="'chats.title' | translate"
              [searchAll]="true" [noHeader]="true" [dataProviderParams]="params"></data-table>
</page-content>
